import React, {ReactElement} from 'react';
import IconWrapper, {IconProps} from '../IconWrapper';

export function MagnifyingGlass(props: IconProps): ReactElement {
  return (
    <IconWrapper {...props}>
      <path
        d="M14.806,13.68L14.215,13.68L14.006,13.479C14.738,12.63 15.179,11.527 15.179,10.328C15.179,7.654 13.005,5.487 10.323,5.487C7.641,5.487 5.467,7.654 5.467,10.328C5.467,13.002 7.641,15.17 10.323,15.17C11.526,15.17 12.632,14.73 13.483,14L13.685,14.209L13.685,14.797L17.42,18.514L18.533,17.404L14.806,13.68ZM10.323,13.68C8.463,13.68 6.961,12.183 6.961,10.328C6.961,8.474 8.463,6.977 10.323,6.977C12.183,6.977 13.685,8.474 13.685,10.328C13.685,12.183 12.183,13.68 10.323,13.68Z"
        fill="currentColor"
      />
    </IconWrapper>
  );
}
